// import Authors from './Authors';
import Cards from './Cards';
import Button from './Button';
// import Calendar from './Calendar';
// import CountryList from './CountryList';
import DateShare from './DateShare';
import Divider from './Divider';
//import Errors from './Errors';
// import Events from './Events';
import Heading from './Heading';
import HeadTitle from './HeadTitle';
import HeroImage from './HeroImage';
import Numbers from './Numbers';
import Subject from './Subject';

export function registerBlocks(config) {
  // Authors(config);
  Cards(config);
  Button(config);
  //Calendar(config);
  //CountryList(config);
  DateShare(config);
  Divider(config);
  // Events(config);
  Heading(config);
  HeadTitle(config);
  HeroImage(config);
  Numbers(config);
  Subject(config);

  // Remover - usado apenas para testes
  //Errors(config);

  return config;
}
